import React from 'react';
import { Box } from '@mui/material';

// Extracts UUID from strings like "홍길동(uuid-here)". Returns '' if no match.
export const extractUUID = (text) => {
    const match = text?.match(/\(([^)]+)\)/);
    return match ? match[1] : '';
};

// Open member detail in a new tab. _blank ensures a new independent tab each call.
export const openUserDetail = (userId) => {
    if (!userId) return;
    window.open(`/user/detail?user_id=${userId}`, '_blank', 'noopener,noreferrer');
};

export const userLinkSx = {
    cursor: 'pointer',
    color: 'primary.main',
    textDecoration: 'underline',
    '&:hover': { color: 'primary.dark' },
};

// Renders text as a clickable link that opens member detail in a new tab.
// If userId is falsy, renders plain text (no link).
export const UserLink = ({ userId, children, sx }) => {
    if (!userId) return <>{children}</>;
    return (
        <Box
            component="span"
            sx={{ ...userLinkSx, ...sx }}
            onClick={() => openUserDetail(userId)}
        >
            {children}
        </Box>
    );
};
